<div class="forbidden-div">
  <h1 class="opacity-08">
    <strong>{{header}}</strong>
  </h1>
  <br />
  <i class="fa fa-ban opacity-06 icon-large" aria-hidden="true"></i>
  <br />
  <h3 class="opacity-05">{{message}}</h3>
  <br />
</div>
